export const ontimeDrawer = {
  header: {
    color: '#fefefe', // $gray-50
    backgroundColor: '#202020', // $gray-1250
  },
  body: {
    color: '#fefefe', // $gray-50
    backgroundColor: '#202020', // $gray-1250
  },
  footer: {
    backgroundColor: '#202020', // $gray-1250
  },
  closeButton: {
    color: '#fefefe', // $gray-50
    _hover: {
      color: '#303030', // $gray-1050
      backgroundColor: '#fefefe', // $gray-50
    },
  },
};
